import { render } from "./Fields.vue?vue&type=template&id=3bcda41b&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"

import "./Fields.vue?vue&type=style&index=0&id=3bcda41b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3bcda41b"

export default script